module.exports = __webpack_public_path__ + "media/img/careers/why-work/why-work-photo2-62b9c716670dc7ed68ec934f75c3fb43.jpg";